module.exports = __webpack_public_path__ + "static/assets/4a5b2948be150153c19da875d1a4f9cf.svg";